// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__139N8","inner":"Footer_inner__1ua4m","nextIcon":"Footer_nextIcon__2BAF6","innerLeft":"Footer_innerLeft__mreo_"};